import { Olkypass_status } from "@/features/kyc/types";
import { IdentityDocumentType } from "@/views/identity/components/level-card-status-container/verified-company-form/types";
import type { NaturalPerson, RealIdentity } from "../types";

export type Document = {
  UUID: string;
  TypePiece: number;
  Number: string;
  Validity: boolean | null;
  OwnerUUID: string;
  NaturalPerson: NaturalPerson | null;
  algoregDocumentId: string;
  typePerLanguage: {
    fr: string;
    en: string;
  };
  selfUpload: boolean;
  Document: DocumentDescription | null;
  uuid: string;
};

export type DocumentDescription = {
  file_mime: MimeType;
  file_name: string;
  display_name: string;
  id: string;
};

export enum MimeType {
  PNG = "image/png",
  JPEG = "image/jpeg",
  PDF = "application/pdf"
}

export type DocumentType = {
  id: number;
  type_fr: string;
  type_en: string;
  need_other_name: boolean;
  need_manual_validation: boolean;
};
export interface ResponseUpdateKyc {
  id: number;
  uuid: string;
  level: number;
  active: boolean;
  algoreg_kyc_status: null;
  active_until: null;
  created_at: string;
  updated_at: string;
  valid_for_pay_in: boolean;
  valid_for_pay_out: boolean;
  algoreg_risk: number;
  creation_source: string;
  type: string;
  reason: null;
  real_identity: RealIdentity;
  olkypass_status_under_audit: Olkypass_status;
}

export type LegalDocument = {
  name: string;
  base64docs: string;
  type?: LegalEntityDocsType;
  identity_document_type?: IdentityDocumentType; // TODO : convert this one to v2
  uuid?: string;
  fileFormat?: string;
};
export type UploadDocument = {
  language: string;
  ownerUUID: string;
  document_type_id?: number;
  document: {
    base64Doc: string;
    fileName: string;
    fileFormat: string;
  };
  isAgentLe?: boolean;
};
export type UploadOlkypassLvl2Response = {
  base64docs: string;
  name: string;
  document_type: LegalEntityDocsType;
};

export type UploadegalDocument = {
  document: {
    base64Doc: string;
    fileName: string;
    fileFormat: string;
  };
};

export enum LegalEntityDocsType {
  COMPANY_IDENTITY_DOCUMENT = "COMPANY_IDENTITY_DOCUMENT",
  SECOND_COMPANY_IDENTITY_DOCUMENT = "SECOND_COMPANY_IDENTITY_DOCUMENT",
  RBE_PROOF = "RBE_PROOF",
  COMPANY_ORGCHART = "COMPANY_ORGCHART",
  ANNUAL_REPPORTS = "ANNUAL_REPPORTS"
}
